import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import ListadoTorneos from './components/ListadoTorneos';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allTorneosAction, setActivoTorneosAction } from './TorneosAction';
import FormTorneos from './components/FormTorneos';
import { ModalComponent } from '../../../widgets';

const TorneosView = () => {
  const dispatch = Redux.useDispatch();

  const torneosStore = Redux.useSelector((state) => state.torneos);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoTorneosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoTorneosAction(dispatch, null);
            await allTorneosAction(dispatch, torneosStore.params);
          }}
          disabled={torneosStore.all.length === 0 || torneosStore.loadingAll}
          white
          refreshIcon
          text={torneosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoTorneos setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <ModalComponent
        id="modalFormTorneos"
        title={`${
          torneosStore.activo
            ? `Editar ${torneosStore.activo.nombre}`
            : 'Nuevo torneo'
        }`}
        maxWidth="sm"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormTorneos
          activo={torneosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default TorneosView;
